import { render, staticRenderFns } from "./VirtualOrgTree.vue?vue&type=template&id=153e343a&scoped=true"
import script from "./VirtualOrgTree.vue?vue&type=script&lang=js"
export * from "./VirtualOrgTree.vue?vue&type=script&lang=js"
import style0 from "./VirtualOrgTree.vue?vue&type=style&index=0&id=153e343a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153e343a",
  null
  
)

export default component.exports